import React from 'react'
import MyPayroll from './MyPayroll'


export default function MigrationFromBranchReport() {
  return (
    <div>
      <MyPayroll />
    </div>
  )
}
